import { computed, reactive, ref } from 'vue';

const pending = reactive(new Set<symbol>());
export const initialViewResolved = ref(false);
export const initialLoadingSkipped = ref(false);
export const initialLoadingFinished = ref(false);
export const navigationLoading = ref(false);
export const queryNavigationLoading = ref(false);
export const initialLoadFailed = ref(false);
export const initialViewReady = computed(
	() => initialViewResolved.value && !navigationLoading.value && pending.size === 0,
);

export function reportInitialLoading(key: symbol, busy: boolean) {
	if (busy && !initialLoadingFinished.value) pending.add(key);
	else pending.delete(key);
}

export const bootstrapFailed = ref(false);
